import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import {
  AddProductionProfilesDatasetDialog,
  ProductionProfilesDatasetsTable
} from './components'
import { useProductionProfiles } from './hooks'

export const ProductionProfilesPage = () => {
  const { isUser } = useCurrentUser()
  const { productionProfilesDatasets, isFetching } = useProductionProfiles()

  const { filteredDatasets, onFilterChange } = useFilterDatasets(
    productionProfilesDatasets
  )

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[{ title: 'Library' }, { title: 'Production Profiles' }]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddProductionProfilesDatasetDialog />}
        </Box>
      }>
      <ProductionProfilesDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
